import { atom } from "jotai";
import { atomFamily } from "jotai-family";

import type { EventFormValues } from "@/types/event";

/** Form values for the event editor, keyed by slug. */
export const eventFormFamily = atomFamily((_slug: string) =>
  atom<EventFormValues | null>(null),
);

/** Last-known DB row for change detection (replaces rawRef). */
export const eventRawFamily = atomFamily((_slug: string) =>
  atom<null | Record<string, unknown>>(null),
);

/** Ticket kind ID from event_ticket_kind[0].id. */
export const eventTicketKindIdFamily = atomFamily((_slug: string) =>
  atom<null | string>(null),
);
